import { render } from "./StyleQuestionView.vue?vue&type=template&id=3f7eefca"
import script from "./StyleQuestionView.vue?vue&type=script&lang=js"
export * from "./StyleQuestionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__